import React, { Component } from 'react';

import './Loader.css';

class Loader extends Component{
  render(){
    var style = {}
    if(this.props.position)
      style = {bottom: this.props.positionFromTop, position: this.props.position, left: '50%', right: 0, transform: 'translateX(-50%)', zIndex: 999 }

    return(
      <div className="Loader container">
        <div className="row">
          <div className="col-md-2 col-md-offset-5">
              <div className="load-wrapp" style={style}>
                  <div className="load-3">
                      <div className="line"></div>
                      <div className="line"></div>
                      <div className="line"></div>
                  </div>
              </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Loader;
